import React from "react";

function AuthHeader({ title, description }) {
  return (
    <div className="auth-head">
      <p>
        {title}
      </p>
      <span>
        {description}
      </span>
    </div>
  );
}

export default AuthHeader;
